export const FLAG_SYSTEM_DISABLED_EVENT = 'smarttile:flag-system-disabled';
const disabledMessage = 'The flag system is not enabled for this customer.';

export const isFlagSystemDisabledError = (error) => {
  if (!error || !error.response || error.response.status !== 403) return false;
  const data = error.response.data;
  const message = typeof data === 'string' ? data : data && data.error;
  return typeof message === 'string' && message.trim() === disabledMessage;
};

export const canReadAdminFlagSystemStatus = (context) => {
  const roles = context && context.rawProfile && context.rawProfile.roles;
  return Boolean(Array.isArray(roles) && roles.length === 1 &&
    ['AdminLevelUser', 'TopLevelUser'].includes(roles[0]));
};
